module.exports = __webpack_public_path__ + "static/media/(DH)-03-Capim-Dourado-bijuterias.2ddb4b7d.jpg";